import React from 'react';
import styled from 'styled-components';

import ImageBlock from './ImageBlock';
import Section from '../layouts/Section';
import Button from '../Button';

import theme from '../../../styles/theme';

const { breakPoints: mobileFirstScreenQuery } = theme;

const AlternatingStackedImageBlockWrapper = styled(Section)`
	.image-block {
		margin-bottom: 20px;

		${mobileFirstScreenQuery.large} {
			margin-bottom: 112px;
		}
	}
`;

const StackedImageBlockSectionHeader = styled(Section)`
	width: ${props => (props.fullWidthHeader ? '100%' : '')};
`;

const AlternatingStackedImageBlocks = ({
	containerOverline,
	containerHeader,
	containerSubheader,
	containerSubheaderHTML,
	containerSubheaderRaw,
	containerCTAButtonText,
	containerCTAButtonLink,
	centerHeader,
	imageBlocks,
	customSplashes,
	noTopPadding,
	noBottomPadding,
	className,
	lineStyle,
	boxStyle,
	sectionColor,
	sectionGradient,
	sectionComplexGradient,
	flipGrid,
	...props
}) => {
	return (
		<AlternatingStackedImageBlockWrapper
			className={className}
			backgroundColor={sectionColor}
			gradient={sectionGradient}
			complexGradient={sectionComplexGradient}
			noTopPadding={noTopPadding}
			noBottomPadding={noBottomPadding}
			{...props}
		>
			{containerHeader && (
				<StackedImageBlockSectionHeader
					centerHeader
					overline={containerOverline}
					header={containerHeader}
					subheader={containerSubheader}
					subheaderHTML={containerSubheaderHTML}
					subheaderRaw={containerSubheaderRaw}
					showOverflow
					css={{ paddingBottom: 60 }}
					{...props}
					noTopPadding
					noBottomPadding
				>
					{containerCTAButtonText && (
						<Button
							className="center-button"
							link={containerCTAButtonLink}
							css={{ marginTop: '0 !important' }}
						>
							{containerCTAButtonText}
						</Button>
					)}
				</StackedImageBlockSectionHeader>
			)}
			{imageBlocks?.length > 0 &&
				imageBlocks.map((entry, index) => {
					const stats = entry.statblock && [
						{
							stat: entry?.statblockStat,
							description: entry?.statblockDescription,
						},
						{
							stat: entry?.statblockStat2,
							description: entry?.statblockDescription2,
						},
					];
					return (
						<ImageBlock
							key={entry.contentful_id || entry?.image?.file?.url}
							flipX={flipGrid ? index % 2 === 0 : index % 2 !== 0}
							overline={entry?.imageBlockOverline || entry?.headerHeadForClPs}
							header={entry.imageBlockTitle || entry.textblockHeader}
							subheader={
								entry?.imageBlockDescription?.childMarkdownRemark?.html ||
								entry?.textSectionNew
							}
							additionalSubheader={entry?.textSectionNew?.references}
							image={
								entry?.imageBlockImage?.file?.url ||
								entry.image ||
								entry?.featureImageOrVideo?.image?.file?.url
							}
							videoLink={entry?.featureImageOrVideo?.videoLink}
							videoThumbnail={entry?.featureImageOrVideo?.videoThumbnail}
							buttons={entry?.additionalLinks}
							imageCaption={entry.imageCaption}
							orangeButton={entry.orangeButton}
							noTopPadding
							noBottomPadding
							gridClass="margin-bottom"
							className="image-block"
							statSection={stats}
							statblockLogo={entry?.statblockLogo?.file?.url}
							lineStyle={lineStyle}
							boxStyle={boxStyle}
							stackedBlock
						/>
					);
				})}
		</AlternatingStackedImageBlockWrapper>
	);
};

export default AlternatingStackedImageBlocks;
